import {Spot, TriggerRule, TriggerRules} from "../../../components/types";
import {FlowEdge, FlowNode} from "../../../components/flowGraph/types";
import {buildSpotRuleGraph} from "./spotRuleGraph";

const NODE_MIN_WIDTH = 150;
const CHAR_WIDTH = 7;
const NODE_HEIGHT = 48;
const START_NODE_WIDTH = 120;

const getRuleLabel = (rule: TriggerRule) => {
    if (rule.eventType === "SPOT_FINISHED_FOR_MS") {
        const value = (rule as TriggerRule & { msSinceFinished?: number }).msSinceFinished;
        return `Require full play + ${value}ms`;
    }
    if (rule.eventType === "SPOT_FINISHED" || rule.eventType === "SPOT_NOT_FINISHED") {
        return "Require full play";
    }
    if (rule.eventType === "AMBIENT_TRIGGERED") {
        return "Require ambient triggered";
    }
    if (rule.eventType === "AMBIENT_NOT_TRIGGERED") {
        return "Require ambient not triggered";
    }
    if (rule.eventType === "AMBIENT_TIME_SINCE_TRIGGERED") {
        return "Require time since ambient";
    }
    return "Require triggered";
};

export const buildFlowGraph = (spots: Spot[]) => {
    const graph = buildSpotRuleGraph(spots);
    const edges: FlowEdge[] = graph.edges.map((edge) => ({
        id: edge.id,
        fromId: edge.fromId,
        toId: edge.toId,
        label: getRuleLabel(edge.rule),
        kind: "rule"
    }));

    graph.startNodeIds.forEach((spotKey, idx) => {
        edges.push({
            id: `start-${spotKey}-${idx}`,
            fromId: "start",
            toId: spotKey,
            label: "",
            kind: "implicit"
        });
    });


    const getNodeWidth = (label: string, isStart?: boolean) => {
        if (isStart) {
            return START_NODE_WIDTH;
        }
        const estimated = label.length * CHAR_WIDTH + 32;
        return Math.max(NODE_MIN_WIDTH, estimated);
    };

    const nodes: FlowNode<{triggerRules?: TriggerRules}>[] = [
        {
            id: "start",
            label: "Start",
            width: getNodeWidth("Start", true),
            height: NODE_HEIGHT,
            kind: "start",
            x: 0,
            y: 0
        },
        ...Array.from(graph.spotByNodeId.values()).map((spot) => ({
            id: spot.key,
            label: spot.name || spot.key,
            width: getNodeWidth(spot.name || spot.key),
            height: NODE_HEIGHT,
            kind: "spot" as const,
            data: {triggerRules: spot.triggerRules},
            x: 0,
            y: 0
        }))
    ];

    return {nodes, edges};
};
